import { AnimatedTheme } from "../.internal/themes/AnimatedTheme";
export default AnimatedTheme;
//# sourceMappingURL=Animated.js.map